import type { FC, HTMLAttributes, MouseEventHandler } from 'react';
import {
  Action,
  ActionWrapper,
  Content,
  ContentWrapper,
  Wrapper,
} from './style';

export type ModalProps = HTMLAttributes<HTMLDivElement> & {
  onClickConfirm?: MouseEventHandler<HTMLButtonElement>;
  onClickCancel?: MouseEventHandler<HTMLButtonElement>;
  isUnrejectable?: boolean;
};

const Modal: FC<ModalProps> = ({
  children,
  onClickConfirm,
  onClickCancel,
  isUnrejectable = false,
  ...props
}) => {
  return (
    <Wrapper>
      <Content {...props}>
        <ContentWrapper>{children}</ContentWrapper>
        <ActionWrapper>
          <Action onClick={onClickConfirm}>확인</Action>
          {!isUnrejectable && <Action onClick={onClickCancel}>취소</Action>}
        </ActionWrapper>
      </Content>
    </Wrapper>
  );
};

export default Modal;
